export default __webpack_public_path__ + "static/media/userprofile.0fb7cafd.svg";